function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useEffect as d, useRef as f } from "react";
import { FocusableMode as p, isFocusableElement as C } from '../utils/focus-management.js';
import { isMobile as M } from '../utils/platform.js';
import { useDocumentEvent as l } from './use-document-event.js';
import { useWindowEvent as T } from './use-window-event.js';
function y(s, m) {
  var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  var i = f(!1);
  d(function () {
    requestAnimationFrame(function () {
      i.current = a;
    });
  }, [a]);
  function c(e, r) {
    if (!i.current || e.defaultPrevented) return;
    var t = r(e);
    if (t === null || !t.getRootNode().contains(t) || !t.isConnected) return;
    var E = function u(n) {
      return typeof n == "function" ? u(n()) : Array.isArray(n) || n instanceof Set ? n : [n];
    }(s);
    var _iterator = _createForOfIteratorHelper(E),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var u = _step.value;
        if (u === null) continue;
        var n = u instanceof HTMLElement ? u : u.current;
        if (n != null && n.contains(t) || e.composed && e.composedPath().includes(n)) return;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return !C(t, p.Loose) && t.tabIndex !== -1 && e.preventDefault(), m(e, t);
  }
  var o = f(null);
  l("pointerdown", function (e) {
    var r, t;
    i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
  }, !0), l("mousedown", function (e) {
    var r, t;
    i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
  }, !0), l("click", function (e) {
    M() || o.current && (c(e, function () {
      return o.current;
    }), o.current = null);
  }, !0), l("touchend", function (e) {
    return c(e, function () {
      return e.target instanceof HTMLElement ? e.target : null;
    });
  }, !0), T("blur", function (e) {
    return c(e, function () {
      return window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null;
    });
  }, !0);
}
export { y as useOutsideClick };